<button
  mat-stroked-button
  class="app-button-export-file"
  matTooltip="Exportar archivo"
  color="primary"
>
  <mat-icon class="icon-centered" svgIcon="file_export"></mat-icon>
</button>
